import React from 'react';

export const FiPayLogo = ({
  className = '',
  iconOnly = false,
  size = 'md',
  textColor = 'text-slate-900',
  invert = false,
}) => {
  const sizeMap = {
    sm: { box: 'w-7 h-7', text: 'text-lg', sub: 'text-[9px]' },
    md: { box: 'w-10 h-10', text: 'text-xl', sub: 'text-[10px]' },
    lg: { box: 'w-14 h-14', text: 'text-2xl', sub: 'text-xs' },
    xl: { box: 'w-20 h-20', text: 'text-3xl', sub: 'text-sm' },
  };

  const currentSize = sizeMap[size];

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {/* Brand Icon SVG matching user's FIPAY emblem */}
      <div
        className={`${currentSize.box} relative rounded-xl bg-gradient-to-br from-[#0c52d6] via-[#0942b0] to-[#042878] p-1.5 shadow-md shadow-blue-900/25 flex items-center justify-center overflow-hidden shrink-0 border border-blue-400/20`}
      >
        {/* Subtle radial sheen */}
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.22), transparent 65%)' }} />

        <svg
          viewBox="0 0 100 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full drop-shadow-sm"
        >
          <defs>
            {/* Top wing gradient */}
            <linearGradient id="topWingGrad" x1="10" y1="20" x2="95" y2="40" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#f0f5ff" />
              <stop offset="60%" stopColor="#ffffff" />
              <stop offset="100%" stopColor="#e2e8f0" />
            </linearGradient>

            {/* Middle wing gradient with soft 3D shading */}
            <linearGradient id="midWingGrad" x1="15" y1="45" x2="90" y2="70" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#cbd5e1" />
              <stop offset="35%" stopColor="#ffffff" />
              <stop offset="100%" stopColor="#f8fafc" />
            </linearGradient>

            {/* Cyan bottom anchor wedge gradient */}
            <linearGradient id="cyanWedgeGrad" x1="25" y1="75" x2="55" y2="105" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#38bdf8" />
              <stop offset="50%" stopColor="#0ea5e9" />
              <stop offset="100%" stopColor="#0284c7" />
            </linearGradient>

            {/* Inner fold shadow */}
            <linearGradient id="foldShadow" x1="15" y1="45" x2="30" y2="60" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#002b80" stopOpacity="0.45" />
              <stop offset="100%" stopColor="#002b80" stopOpacity="0" />
            </linearGradient>
          </defs>

          {/* Top Wing Blade */}
          <path
            d="M 12,50 C 15,35 32,24 55,20 C 72,16 92,20 98,22 C 96,25 78,35 60,42 C 42,48 24,53 12,50 Z"
            fill="url(#topWingGrad)"
          />

          {/* Middle Wing Blade */}
          <path
            d="M 17,73 C 14,64 19,55 35,49 C 50,44 70,44 83,46 C 75,54 58,64 42,69 C 30,73 20,74 17,73 Z"
            fill="url(#midWingGrad)"
          />
          {/* Subtle shading on fold */}
          <path
            d="M 17,73 C 15,68 18,59 28,54 C 23,62 20,69 17,73 Z"
            fill="url(#foldShadow)"
          />

          {/* Bottom Electric Cyan Wedge */}
          <path
            d="M 28,73 C 35,76 45,74 54,67 C 46,78 40,94 43,103 C 37,97 32,87 28,73 Z"
            fill="url(#cyanWedgeGrad)"
          />
        </svg>
      </div>

      {/* Brand Typography */}
      {!iconOnly && (
        <div className="flex flex-col leading-none select-none">
          <div className="flex items-center tracking-tight">
            <span className="font-extrabold text-blue-600 tracking-tight text-xl">Fi</span>
            <span className={`font-extrabold ml-1 tracking-tight text-xl ${invert ? 'text-white' : textColor}`}>
              Pay
            </span>
            <span className="font-bold ml-1 text-slate-500 tracking-tight text-xl">Bills</span>
          </div>
          <span className="text-[10px] uppercase font-semibold tracking-wider text-slate-400 mt-0.5">
            Fintech &amp; Banking Solutions
          </span>
        </div>
      )}
    </div>
  );
};
